let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b091r")).then(() => parcelRequire('9ucVa'));